var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00CCFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    className: "st0",
    width: 147.3,
    height: 147.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.9,
    y: 175.8,
    className: "st0",
    width: 147.3,
    height: 147.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.7,
    y: 175.8,
    className: "st0",
    width: 147.3,
    height: 147.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.7,
    y: 347.7,
    className: "st0",
    width: 147.3,
    height: 147.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.9,
    y: 347.7,
    className: "st0",
    width: 147.3,
    height: 147.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsCart);
export default __webpack_public_path__ + "static/media/cs-cart.c332bed465d5b1265316774817c43183.svg";
export { ForwardRef as ReactComponent };